import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Ques from '../components/test/Ques';

export default class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      answers: [],
      results: [],
      user: JSON.parse(localStorage.getItem('tpuser'))
    };

    // Fast redirection?
    if (!this.state.user) window.location.replace('/login');

    // Bindings
    this.onRespond = this.onRespond.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.questionList();
    this.userData();
  }

  onRespond = (e) => {
    const state = this.state;
    //state[e.target.name] = e.target.value;
    //this.setState(state);

    let found = state.answers.find((a) => {
      return a.qid === e.target.dataset.qid;
    });
    if (found) found.value = e.target.value;
    else
      state.answers.push({ qid: e.target.dataset.qid, value: e.target.value });

    console.log(this.state);
  };

  onSubmit = (e) => {
    const formData = this.state.answers;
    if (formData.length < this.state.questions.length)
      return alert('Debes responder todas las preguntas.');

    fetch(process.env.REACT_APP_API_URL + '/test/process', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token
      },
      body: JSON.stringify({ answers: formData })
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ results: data });
        const result = data.result.join('').toLowerCase();
        this.props.history.push('/bars/' + result);
        window.dataLayer.push({ event: 'EnvioTest' });
      })
      .catch((err) => console.log(err));
  };

  questionList() {
    fetch(process.env.REACT_APP_API_URL + '/questions/test', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ questions: data });
      })
      .catch((err) => console.log(err));
  }

  userData() {
    fetch(process.env.REACT_APP_API_URL + '/users/me', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          user: { ...this.state.user, ...data },
          results: data.results
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    const results = this.state.results.result
      ? this.state.results.result.map((r, ri) => {
          return (
            <h4 key={'result-' + ri} className='text-right'>
              {r}
            </h4>
          );
        })
      : [];

    const preguntas = this.state.questions.map((q, qi) => {
      return <Ques key={'key-' + qi} item={q} onRespond={this.onRespond} />;
    });

    const myResult = this.state.user.results
      ? this.state.user.results[this.state.user.results.length - 1]
      : false;

    return (
      <div id='test' className='container'>
        {myResult && (
          <div className='row margin-bot-20'>
            <div className='col-sm-10 offset-sm-1'>
              <div className='alert alert-warning text-center'>
                <h4>
                  <b>Tu resultado</b>: {myResult.data.result.join('')}-
                  {myResult.data.identity}
                </h4>
                Revisa el detalle de{' '}
                <Link
                  to='/mypersonality'
                  style={{ color: '#000', fontWeight: 'bold' }}>
                  tu resultado acá
                </Link>
                .
              </div>
            </div>
          </div>
        )}

        <div className='row'>
          <div className='col-sm-3 col-xs-12 border-right-1 margin-top-10 offset-1'>
            <h4 className='title'>Instrucciones</h4>
            <div className='row margin-top-30'>
              <div className='col-4'>
                <img src='/img-tipos/logos/test01.svg' />
              </div>
              <div className='col-8 margin-top-10'>
                <p className='margin-0'>Sé honesto</p>
                <p className='margin-0 red'>
                  <i>(aunque duela)</i>
                </p>
              </div>
            </div>
            <div className='row margin-top-30'>
              <div className='col-4'>
                <img src='/img-tipos/logos/test02.svg' />
              </div>
              <div className='col-8 margin-top-10'>
                <p className='margin-0'>Intenta no ser neutro</p>
                <p className='margin-0 red'>
                  <i>(juégatela por uno)</i>
                </p>
              </div>
            </div>
            <div className='row margin-top-30'>
              <div className='col-4'>
                <img src='/img-tipos/logos/test03.svg' />
              </div>
              <div className='col-8 margin-top-10'>
                <p className='margin-0'>Descubre tus resultados</p>
                <p className='margin-0 red'>
                  <i>(y compártelos)</i>
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-7 text-center'>
            {preguntas}

            <a
              href='#'
              className='btn btn-lg btn-black'
              onClick={this.onSubmit}>
              Ver Resultado del Test
            </a>
          </div>
        </div>
        <div>{results}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Test.jsx